import { render, staticRenderFns } from "./SectionModal.vue?vue&type=template&id=67828afe&"
import script from "./SectionModal.vue?vue&type=script&lang=ts&"
export * from "./SectionModal.vue?vue&type=script&lang=ts&"
import style0 from "./SectionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports